export const cities = [
  // GSC data — already getting impressions
  { slug: 'portland-or', city: 'Portland', state: 'OR', stateFullName: 'Oregon' },
  { slug: 'nashville-tn', city: 'Nashville', state: 'TN', stateFullName: 'Tennessee' },
  { slug: 'jacksonville-fl', city: 'Jacksonville', state: 'FL', stateFullName: 'Florida' },
  { slug: 'houston-tx', city: 'Houston', state: 'TX', stateFullName: 'Texas' },
  { slug: 'charlotte-nc', city: 'Charlotte', state: 'NC', stateFullName: 'North Carolina' },
  { slug: 'san-diego-ca', city: 'San Diego', state: 'CA', stateFullName: 'California' },
  { slug: 'baton-rouge-la', city: 'Baton Rouge', state: 'LA', stateFullName: 'Louisiana' },
  { slug: 'scottsdale-az', city: 'Scottsdale', state: 'AZ', stateFullName: 'Arizona' },
  { slug: 'fort-worth-tx', city: 'Fort Worth', state: 'TX', stateFullName: 'Texas' },
  { slug: 'chicago-il', city: 'Chicago', state: 'IL', stateFullName: 'Illinois' },

  // High-demand expansion markets
  { slug: 'dallas-tx', city: 'Dallas', state: 'TX', stateFullName: 'Texas' },
  { slug: 'phoenix-az', city: 'Phoenix', state: 'AZ', stateFullName: 'Arizona' },
  { slug: 'atlanta-ga', city: 'Atlanta', state: 'GA', stateFullName: 'Georgia' },
  { slug: 'orlando-fl', city: 'Orlando', state: 'FL', stateFullName: 'Florida' },
  { slug: 'denver-co', city: 'Denver', state: 'CO', stateFullName: 'Colorado' },
];

/** Lookup a city object by its URL slug */
export function getCityBySlug(slug) {
  return cities.find((c) => c.slug === slug) || null;
}
